import { render, staticRenderFns } from "./MyReportingUnits.vue?vue&type=template&id=e42f9790&scoped=true"
import script from "./MyReportingUnits.vue?vue&type=script&lang=js"
export * from "./MyReportingUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42f9790",
  null
  
)

export default component.exports